module.exports = __webpack_public_path__ + "img/h_product_45.78f7395.jpg";